const $ = jQuery.noConflict();

'use strict';
const pageNavigation = {
	/**
	* @description Cache dom and strings
	* @type {object}
	*/
	
	/** @description Initialize */
	init: function() {
		$('.page-navigation__link').mouseover(function() {
			$(this).addClass('js-show-link');
		});
		$('.page-navigation__link').mouseout(function() {
			$(this).removeClass('js-show-link');
		});
		$('.page-navigation__list li a[href*=#]').on('click', function(e) {
			e.preventDefault();
			$('.page-navigation__list li a').removeClass('active-link');
			const target = $(this).attr('href');
			$('html, body').stop().animate({
				scrollTop: $(target).offset().top
			}, 2200, function() {
				location.hash = target;
			});
			return false;
		});
		$(window).scroll(function() {
			clearTimeout($.data(this, 'scrollTimer'));
			const scrollDistance = $(window).scrollTop();
			$.data(this, 'scrollTimer', setTimeout(function() {
				$('.block-lists__box').each(function(i) {
					if ($(this).position().top - 200 <= scrollDistance) {
						$('.page-navigation__list li a.active-link').removeClass('active-link');
						$('.page-navigation__list li a').eq(i).addClass('active-link');
						$('.page-navigation__link').removeClass('js-show-link');
					}
				});
			}, 100));
		}).scroll();

		$('.site-footer__description-link').on('click', (function () {
			$('.js-box-shown').trigger('click');
			if (!$(this).parent().parent().find('.site-footer__acc').hasClass('is-active')) {
				$('.js-box-shown').trigger('click');
			}
		}));
	},

	/** @description Bind Events */
};

export default pageNavigation;